import React from "react"
import { Card, CardBody, Table } from "reactstrap"
import { useTranslation } from "react-i18next"

import Paginations from "components/Common/Pagination"
import NoDataAvailable from "components/Shared/NoDataAvailable"

const headers = [
  "S. No.",
  "National Id",
  "First Name",
  "Middle Name",
  "Last Name",
  "Email",
  "Phone Number",
  "Job Title",
]

const CandidatesDataTable = ({
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  loading,
  data = [],
  payload,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  return (
    <>
      <Card className="user_personal_info theme_card overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((item, index) => (
                    <th key={index}>{t(item)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!loading && data.length === 0 ? (
                  <NoDataAvailable />
                ) : (
                  data.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">
                        {(currentPage - 1) * (payload.limit || 50) + index + 1}
                      </th>
                      <td>{item.national_id}</td>
                      <td>
                        {language === "en"
                          ? item.first_name || "-"
                          : item.first_name_ar || "-"}
                      </td>
                      <td>
                        {language === "en"
                          ? item.middle_name || "-"
                          : item.middle_name_ar || "-"}
                      </td>
                      <td>
                        {language === "en"
                          ? item.last_name || "-"
                          : item.last_name_ar || "-"}
                      </td>
                      <td>{item.email}</td>
                      <td>{item.phone_number}</td>
                      <td>{item.job_title || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {!loading && data.length === 0 && <NoDataAvailable />}
      {!loading && data.length > 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
    </>
  )
}

export default CandidatesDataTable
